/**
 * Inea avatar mark — petit badge rond avec l'avatar de la coach IA.
 * Halo conique gradient signature (DA network-ia.io).
 */
export function IneaMark({ size = 44 }: { size?: number }) {
  return (
    <span className="relative inline-flex shrink-0" style={{ width: size, height: size }}>
      <span
        className="absolute inset-[-18%] rounded-full opacity-70 blur-md"
        style={{
          background:
            'conic-gradient(from 0deg, #3b82f6, #a855f7, #ec4899, #f472b6, #60a5fa, #3b82f6)',
        }}
      />
      <img
        src="/brand/inea/avatar.webp"
        alt="Inea"
        className="relative h-full w-full rounded-full object-cover ring-2 ring-white/80"
      />
    </span>
  );
}
